import { Component, OnInit } from '@angular/core';
 
declare var AOS:any;
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.animation_foot();
  }
  animation_foot()
  {
    AOS.init();
  }

}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_includes/footer/footer.component.ts